export const styles = {
  page: (isMobile) => ({
    padding: isMobile ? 12 : 28,
    flex: 1,
    minHeight: !isMobile ? "100%" : "auto",
    minWidth: !isMobile ? 0 : "auto",
    boxSizing: "border-box",
    overflowY: "auto",
    height: isMobile ? "90%" : "100vh",
    background: "linear-gradient(180deg, #f8fbff 0%, #eef4ff 100%)",
  }),
  headerRow: (isMobile) => ({
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: isMobile ? "flex-start" : "center",
    gap: isMobile ? 8 : 14,
    marginBottom: isMobile ? 16 : 24,
  }),
  iconBadge: (isMobile) => ({
    width: isMobile ? 44 : 48,
    height: isMobile ? 44 : 48,
    borderRadius: isMobile ? 12 : 14,
    display: "grid",
    placeItems: "center",
    background: "linear-gradient(135deg, #1f3a70, #3d5bb8)",
    color: "#fff",
    boxShadow: "0 16px 32px rgba(31, 58, 112, 0.14)",
  }),
  title: (isMobile) => ({
    margin: 0,
    fontSize: isMobile ? 20 : 22,
    color: "#1f3a70",
  }),
  subtitle: (isMobile) => ({
    margin: isMobile ? "4px 0 0" : "6px 0 0",
    fontSize: isMobile ? 13 : 14,
    color: "#5d6f8a",
    lineHeight: isMobile ? 1.4 : 1.5,
  }),
  card: (isMobile) => ({
    width: "100%",
    background: "rgba(255,255,255,0.98)",
    borderRadius: 22,
    padding: isMobile ? 16 : 28,
    boxShadow: "0 20px 50px rgba(34, 60, 80, 0.08)",
    border: "1px solid rgba(31, 58, 112, 0.08)",
    boxSizing: "border-box",
    position: "relative",
  }),
  sectionHeader: (isMobile) => ({
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    justifyContent: "space-between",
    gap: isMobile ? 12 : 16,
    alignItems: "flex-start",
    marginBottom: isMobile ? 16 : 24,
  }),
  cardTitle: (isMobile) => ({
    margin: 0,
    fontSize: isMobile ? 16 : 18,
    color: "#15233c",
    fontWeight: 700,
  }),
  cardDescription: (isMobile) => ({
    margin: isMobile ? "6px 0 0" : "8px 0 0",
    color: "#6a7c96",
    fontSize: isMobile ? 13 : 14,
  }),
  toolbarContainer: (isMobile) => ({
    display: "flex",
    flexDirection: "column",
    gap: isMobile ? 10 : 12,
    marginBottom: isMobile ? 16 : 18,
  }),
  searchWrapper: (isMobile) => ({
    position: "relative",
    display: "flex",
    alignItems: "center",
    marginBottom: isMobile ? 8 : 0,
  }),
  searchIcon: (isMobile) => ({
    position: "absolute",
    left: isMobile ? 12 : 14,
    color: "#5d6f8a",
    pointerEvents: "none",
  }),
  searchInput: (isMobile) => ({
    width: "100%",
    padding: isMobile ? "10px 14px 10px 40px" : "12px 14px 12px 44px",
    borderRadius: isMobile ? 14 : 16,
    border: "1px solid rgba(31, 58, 112, 0.14)",
    fontSize: isMobile ? 13 : 14,
    color: "#223047",
    outline: "none",
    boxSizing: "border-box",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
  }),
  toolbarActions: (isMobile) => ({
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    gap: 10,
    alignItems: isMobile ? "stretch" : "center",
    width: isMobile ? "100%" : "auto",
  }),
  sortSelect: (isMobile) => ({
    padding: isMobile ? "12px 14px" : "10px 12px",
    borderRadius: 12,
    border: "1px solid rgba(31, 58, 112, 0.14)",
    fontSize: isMobile ? 14 : 13,
    color: "#223047",
    background: "#ffffff",
    cursor: "pointer",
    outline: "none",
    transition: "border-color 0.2s ease",
    width: isMobile ? "100%" : "auto",
  }),
  addButton: (isMobile) => ({
    padding: isMobile ? "12px 16px" : "10px 16px",
    borderRadius: 12,
    border: "none",
    background: "linear-gradient(135deg, #1f3a70, #3d5bb8)",
    color: "#fff",
    fontSize: isMobile ? 14 : 13,
    fontWeight: 700,
    cursor: "pointer",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    boxShadow: "0 8px 16px rgba(31, 58, 112, 0.16)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    whiteSpace: "nowrap",
    width: isMobile ? "100%" : "auto",
  }),
  addButtonIcon: (isMobile) => ({
    marginTop: -1,
    marginRight: isMobile ? 4 : 0,
  }),
  iaList: (isMobile) => ({
    display: "grid",
    gap: 14,
    borderRadius: 14,
    background: "rgba(31, 58, 112, 0.02)",
  }),
  iaItem: (isMobile) => ({
    display: isMobile ? "flex" : "flex",
    flexDirection: isMobile ? "column" : "row",
    justifyContent: isMobile ? "flex-start" : "space-between",
    alignItems: isMobile ? "flex-start" : "flex-start",
    gap: isMobile ? 12 : 14,
    padding: isMobile ? 14 : 18,
    borderRadius: isMobile ? 16 : 18,
    background: "#f7f9ff",
    border: "1px solid rgba(31, 58, 112, 0.08)",
    marginBottom: 12,
    position: isMobile ? "relative" : "static",
  }),
  iaPhoto: (isMobile) => ({
    width: isMobile ? 48 : 56,
    height: isMobile ? 48 : 56,
    borderRadius: isMobile ? 10 : 12,
    objectFit: "cover",
    flexShrink: 0,
    border: "2px solid rgba(31, 58, 112, 0.1)",
  }),
  iaContent: (isMobile) => ({
    flex: 1,
    minWidth: 0,
    marginLeft: isMobile ? 0 : 14,
  }),
  iaHeader: (isMobile) => ({
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    justifyContent: isMobile ? "flex-start" : "space-between",
    alignItems: isMobile ? "flex-start" : "flex-start",
    gap: isMobile ? 8 : 12,
    width: isMobile ? "100%" : "auto",
    marginBottom: 8,
  }),
  iaTitle: (isMobile) => ({
    margin: 0,
    fontSize: isMobile ? 15 : 16,
    color: "#15233c",
    fontWeight: 700,
  }),
  iaFunction: (isMobile) => ({
    margin: isMobile ? "2px 0 0" : "4px 0 0",
    fontSize: isMobile ? 12 : 13,
    color: "#5d6f8a",
  }),
  tagBadge: (isMobile) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: isMobile ? "4px 8px" : "6px 10px",
    borderRadius: 999,
    fontSize: isMobile ? 11 : 12,
    fontWeight: 700,
    background: "rgba(31, 58, 112, 0.12)",
    color: "#1f3a70",
  }),
  iaDescription: (isMobile) => ({
    margin: 0,
    color: "#5d6f8a",
    fontSize: isMobile ? 12 : 13,
    lineHeight: isMobile ? 1.4 : 1.5,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  }),
  iaMeta: (isMobile) => ({
    whiteSpace: isMobile ? "nowrap" : "nowrap",
    fontSize: isMobile ? 11 : 13,
    color: "#1f3a70",
    fontWeight: isMobile ? 600 : 700,
    position: isMobile ? "absolute" : "static",
    top: isMobile ? 12 : "auto",
    right: isMobile ? 12 : "auto",
    background: isMobile ? "rgba(255,255,255,0.9)" : "transparent",
    padding: isMobile ? "3px 6px" : 0,
    borderRadius: isMobile ? 6 : 0,
    border: isMobile ? "1px solid rgba(31, 58, 112, 0.1)" : "none",
  }),
  iaPhotoFallback: (isMobile) => ({
    width: isMobile ? 48 : 56,
    height: isMobile ? 48 : 56,
    borderRadius: isMobile ? 10 : 12,
    background: "linear-gradient(135deg, #e5e7eb 0%, #f3f4f6 100%)",
    border: "2px solid rgba(31, 58, 112, 0.1)",
    display: "grid",
    placeItems: "center",
    color: "#9ca3af",
  }),
  emptyState: (isMobile) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: isMobile ? 24 : 48,
    gap: 16,
    color: "#cbd5e1",
  }),
  emptyMessage: {
    margin: 0,
    color: "#5d6f8a",
    fontSize: 14,
  },
  loadingOverlay: (isMobile) => ({
    position: "absolute",
    inset: 0,
    background: "rgba(255, 255, 255, 0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 22,
    zIndex: 10,
  }),
  spinner: (isMobile) => ({
    width: 40,
    height: 40,
    border: "3px solid rgba(31, 58, 112, 0.1)",
    borderTop: "3px solid #1f3a70",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  }),
  spinnerSmall: (isMobile) => ({
    width: 24,
    height: 24,
    border: "2px solid rgba(31, 58, 112, 0.1)",
    borderTop: "2px solid #1f3a70",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  }),
};
